import React from 'react';

function About() {
  const sectionStyle = {
    '--background-image': `url(${process.env.PUBLIC_URL}/media/banners/mgg-black-body.png)`
  };

  return (
    <section className="about" id="about" style={sectionStyle}>
      <div className="ambient-particles"></div>
      <div className="row" data-aos="fade-up" data-aos-offset="200">
        <div className="col50" data-aos="fade-right" data-aos-delay="100">
          <h2 className="title-text">
            <lord-icon
              src="https://cdn.lordicon.com/nocovwne.json"
              trigger="loop"
              colors="primary:#962f2f,secondary:#ffffff"
              stroke="66"
              style={{width: '50px', height: '50px', marginTop: '-10px'}}
            ></lord-icon>
            About <span>Us</span>
          </h2>
          <div className="content-wrapper">
            <p className="fade-in-text">
              Welcome to Midnight Ghoul Games, where passion meets innovation in game development. 
              As an independent studio, we're driven by our commitment to creating cutting-edge, 
              community-driven experiences that push the boundaries of interactive entertainment.
            </p>
            <p className="fade-in-text" data-aos="fade-up" data-aos-delay="200">
              Our mission is to craft games that not only captivate with stunning visuals but also 
              engage through rich, thoughtful design. We believe in the power of community feedback 
              and collaboration, making our players an integral part of our creative journey.
            </p>
            <p className="fade-in-text" data-aos="fade-up" data-aos-delay="300">
              From intense action sequences to immersive storytelling, every project we undertake 
              is crafted with meticulous attention to detail and a deep appreciation for what makes 
              games truly memorable.
            </p>
          </div>
        </div>
        <div className="col50" data-aos="fade-left" data-aos-delay="200">
          <div className="imgBx">
            <div className="image-overlay"></div>
            <img src={`${process.env.PUBLIC_URL}/media/banners/mgg-black-body.png`} alt="Midnight Ghoul Games" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
